import { RadioGroup } from '@/components/atoms/RadioGroup/RadioGroup';

import { CareFilterChoiceProps } from '../CareProviderSearchSidebar/CareProviderSearchSidebar';

export const CareTypePicker = ({
  selectedValue,
  setSelectedValue,
  allValues,
}: CareFilterChoiceProps) => {
  return (
    <RadioGroup
      onChange={setSelectedValue}
      value={selectedValue}
      options={[...allValues]}
      variant='default'
    />
  );
};
